import { render, staticRenderFns } from "./tagSelector.vue?vue&type=template&id=1cd297e3&scoped=true&"
import script from "./tagSelector.vue?vue&type=script&lang=js&"
export * from "./tagSelector.vue?vue&type=script&lang=js&"
import style0 from "./tagSelector.vue?vue&type=style&index=0&id=1cd297e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd297e3",
  null
  
)

export default component.exports